import { BadgePropsColorOverrides } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';

export const processStatuses = {
  interrupted: 'interrupted',
  processing: 'processing',
  finished: 'finished',
  failed: 'failed',
  validated: 'validated',
} as const;

export type Statuses = (typeof processStatuses)[keyof typeof processStatuses];

export type CheckNotReadStatusResponse = {
  processes: Process[];
};

export type Process = {
  id: number;
  title: string;
  bms_section: string;
  filename: string;
  status: Statuses;
};

export type BadgeColorAndNumber = {
  number: number;
  color: OverridableStringUnion<
    'primary' | 'error' | 'success' | 'default' | 'info' | 'warning' | 'secondary',
    BadgePropsColorOverrides
  >;
};
